import { FC } from 'react';

import WarningIcon from '@mui/icons-material/Warning';
import { SvgIconProps } from '@mui/material';

type CatastrophicProps = SvgIconProps;

export const Catastrophic: FC<CatastrophicProps> = ({ width, color }) => (
  <WarningIcon
    role="img"
    sx={{ fontSize: width ?? '24px' }}
    color={color ?? 'error'}
  />
);
